/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import { fireUtagEvent, fireUtagView } from './analyticsUtils.js';
import AnalyticsConfig from './config/analyticsConfig.js';

/**
 * @deprecated
 * Use utility functions from analyticsUtils instead
 * We no longer need to account for legacy tracking and the utility methods provide easier
 * consumption for consuming appplications.
 * This includes updated features from the official Garmin Analytics package
 */
export default class Analytics {
  static trackAnalyticsEvent(params) {
    const eventPayload = { ...(params || {}) };
    // eslint-disable-next-line max-len
    const hasEventData = (eventPayload?.event_category || eventPayload?.event_label || eventPayload?.event_action);
    let analyticsEvent = hasEventData ? params : false;

    if (params?.manualAnalyticsEvent) {
      analyticsEvent = params.manualAnalyticsEvent;
      delete eventPayload.manualAnalyticsEvent;
    } else if (params?.manualId) {
      analyticsEvent = this.getAnalyticsEventParams(params.manualId);
      delete eventPayload.manualId;
    }

    if (analyticsEvent) {
      analyticsEvent = {
        event_category: analyticsEvent?.category,
        event_action: analyticsEvent?.action,
        event_label: analyticsEvent?.label,
        ...eventPayload,
      };

      fireUtagEvent(analyticsEvent);
    }
  }

  static getAnalyticsEventParams(elemId) {
    return AnalyticsConfig?.analyticsEvents?.[elemId];
  }

  static sendPageview(url, title, pageViewEventData = {}) {
    fireUtagView(pageViewEventData);
  }
}
